import { useEffect, useState } from "react";
import api from "../lib/api";

export default function AdSlot({ placement = "sidebar" }) {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    api.get("/ads", { params: { placement, active: true } })
      .then(r => setAds(r.data || []))
      .catch(() => {});
  }, [placement]);

  if (!ads.length) return null;
  const ad = ads[Math.floor(Math.random() * ads.length)];

  const onClick = () => { api.post(`/ads/${ad.id}/click`).catch(() => {}); };

  const content = (
    <div className="border border-zinc-300 bg-white" data-testid={`ad-${placement}`}>
      <p className="overline text-zinc-400 px-3 pt-2">Publicidade</p>
      {ad.html_or_image?.startsWith("http") ? (
        <img src={ad.html_or_image} alt={ad.name} className="w-full" />
      ) : (
        <div className="p-4" dangerouslySetInnerHTML={{ __html: ad.html_or_image }} />
      )}
    </div>
  );

  return ad.link ? (
    <a href={ad.link} target="_blank" rel="noopener noreferrer" onClick={onClick}>{content}</a>
  ) : content;
}
